/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBowlChopsticksFilled = createReactComponent("filled", "bowl-chopsticks-filled", "IconBowlChopsticksFilled", [["path", { "d": "M20 10a2 2 0 0 1 2 2v.5c0 1.694 -2.247 5.49 -3.983 6.983l-.017 .013v.504a2 2 0 0 1 -1.85 1.995l-.15 .005h-8a2 2 0 0 1 -2 -2v-.496l-.065 -.053c-1.76 -1.496 -3.794 -4.965 -3.928 -6.77l-.007 -.181v-.5a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M18.929 6.003a1 1 0 1 1 .142 1.994l-14 1a1 1 0 1 1 -.142 -1.994z", "key": "svg-1" }], ["path", { "d": "M18.79 1.022a1 1 0 1 1 .42 1.956l-14 3a1 1 0 1 1 -.42 -1.956z", "key": "svg-2" }]]);

export { IconBowlChopsticksFilled as default };
//# sourceMappingURL=IconBowlChopsticksFilled.mjs.map
